import React, {useState, useEffect} from 'react'
import {LoadEffect}  from '../component/loader'
import PageHeader from '../component/pageheader'
import { Alerts } from '../component/notify'

import {ServerUrl, Token, config, classID, sectionID} from '../../component/include'
import axios from 'axios'
import { convertDate, getClassName, getDays, longDate, getTime} from '../component/globalFunction'
import {Line} from 'react-chartjs-2'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'


// Import styled-components for better CSS organization
import styled from 'styled-components';

// Custom styled components for the dashboard
const DashboardStyles = styled.div`
  .border-left-primary {
    border-left: 0.25rem solid #4e73df !important;
  }
  .border-left-success {
    border-left: 0.25rem solid #1cc88a !important;
  }
  .border-left-info {
    border-left: 0.25rem solid #36b9cc !important;
  }
  .border-left-warning {
    border-left: 0.25rem solid #f6c23e !important;
  }
  .text-xs {
    font-size: 0.7rem;
  }
  .text-gray-800 {
    color: #5a5c69 !important;
  }
  .shadow {
    box-shadow: 0 .15rem 1.75rem 0 rgba(58,59,69,.15) !important;
  }
  .chart-area {
    position: relative;
    height: 20rem;
    width: 100%;
  }
  .quick-access-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    border-radius: 0.35rem;
    box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.1);
    transition: all 0.3s ease;
    cursor: pointer;
    height: 100%;
  }
  .quick-access-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 0.5rem 2rem 0 rgba(58, 59, 69, 0.15);
  }
  .icon-circle {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 3rem;
    width: 3rem;
    border-radius: 100%;
    margin-bottom: 1rem;
  }
  .bg-primary {
    background-color: #4e73df !important;
  }
  .bg-success {
    background-color: #1cc88a !important;
  }
  .bg-info {
    background-color: #36b9cc !important;
  }
  .bg-warning {
    background-color: #f6c23e !important;
  }
  .bg-danger {
    background-color: #e74a3b !important;
  }
  .bg-secondary {
    background-color: #858796 !important;
  }
  .quick-access-title {
    font-weight: 600;
    text-align: center;
  }
  .calendar-container .fc-toolbar-title {
    font-size: 1.2rem !important;
  }
  .calendar-container .fc-button {
    background-color: #4e73df !important;
    border-color: #4e73df !important;
  }
  .calendar-container .fc-button:hover {
    background-color: #2e59d9 !important;
    border-color: #2e59d9 !important;
  }
  .calendar-container .fc-button:focus {
    box-shadow: 0 0 0 0.2rem rgba(78, 115, 223, 0.25) !important;
  }
  @media (max-width: 768px) {
    .chart-area {
      height: 15rem;
    }
    .calendar-container {
      height: 300px !important;
    }
  }
`;


const Dashboard =()=> {
    
const [notice, setNotice] = useState({
    isLoading : false, 
    isDataFetching: false,
})
const [CurrentSession, setCurrentSession] = useState('')
    const [allHolidays, setAllHolidays]= useState([])    
   
   

const [attendance, setAttendance] = useState([])
const [attendanceAbsent, setAttendanceAbsent] = useState([])
var today = new Date().toISOString().slice(0,10);

const [schoolClass, setSchoolClass]=useState([]);

const [statistics, setStatistics] = useState({
    student:0,
    absent:0,
    present:0,
    male:0,
    female:0
});



const [allHoliday, setAllHoliday]= useState([])
    
const fetchAllHoliday =()=>{

  const fd = new FormData();
  fd.append('jwt', Token);
    let sql = "Select startDate as date, eventType as event, color as colors, title as comment,  startTime as begin, endTime as stop from tbl_events_holidays "

        let url = ServerUrl+'/fetchBySql_controller'
      
        fd.append("sql", sql)
       
        axios.post(url, fd, config).then(result =>setAllHoliday(result.data)) 
}

    const fetchAllHolidays =()=>{
      
        const fd = new FormData();
        let sql = "Select * from tbl_events_holidays where  sessionYear = '"+CurrentSession+"'  order by startDate DESC"
     
            let url = ServerUrl+'/fetchBySql_controller'
            fd.append("jwt", Token)
            fd.append("sql", sql)
            axios.post(url, fd, config).then(result =>setAllHolidays(result.data)) 
    }

    const tableHeader = [
        {dataField: 'eventType', text: 'Title', editable:false},
        {dataField: 'title', text: 'Reason', sort:true, editable:false},
        {dataField: 'startDate', text: 'Date',sort:true, editable:false, formatter: (cell, row)=>`${longDate(cell)} `},       
        {dataField: 'endDate', text: 'Day', editable:false, sort:true, formatter: (cell, row)=>getDays(row.startDate)}
     ];


     const HolidayTable=(props)=>{

       
  
       
         const { SearchBar } = Search;
     
         const customTotal = (from, to, size) => (
            <span >&nbsp;Showing { from } to { to } of { size } items</span>
          );
         const options = {
             showTotal: true,
         paginationTotalRenderer: customTotal,
         sizePerPageList: [{text: '100', value: 100}, {text: '200', value: 200}, {text: '500', value: 500},
         { text: 'All', value: props.data.length }]
            
           };
      
         return <ToolkitProvider search columnToggle 
                     keyField='ID' data={ props.data } columns={ props.columns } >
                         
                         {
                             props => (
                             <div >
                               <div className="form-group">
                                 <SearchBar
                                 { ...props.searchProps } style={{height:'40px'}} className="form-control" placeholder="Type to search!!!" />
                                 &nbsp;
                               
                                 </div>
                                 
                          
                 
                                 <BootstrapTable
                                 { ...props.baseProps }
                                             striped
                                         hover
                                         condensed
                                         noDataIndication={<div className="alert alert-danger background-danger">No Record Found</div>}
                                     pagination={paginationFactory(options) }
                                    
                                 />
                             </div>
                             )
                         }
      </ToolkitProvider>
      }
    





      const  handleSession =()=>{

        var sql ="Select  startYear from tbl_school_session where status ='Active'"
        const fd = new FormData();
        fd.append("sql", sql);
        fd.append("jwt", Token);
        let url = ServerUrl+'/fetchBySql_controller';
        axios.post(url, fd, config)
        .then(result => {
            if(result.data.length!==0){
            setCurrentSession(result.data[0].startYear)
        }
        })
        .catch((error)=>{
            Alerts('Error!', 'danger', JSON.stringify(error.message)) 
        })
        }
    

   
      


      const  handleFetchClass =()=>{
            
        const fd = new FormData(); 
        fd.append('jwt', Token);
                let url = ServerUrl + '/fetchField/tbl_school_class/schoolClass/ID/1'
                axios.post(url, fd, config)
                .then(result => setSchoolClass(result.data))
                .catch((error)=>Alerts('Error!', 'danger', JSON.stringify(error.message))) 
                    
            }


      const fetchAttendance =()=>{
        var date = new Date()
        const day = 1000 * 60 * 60 * 24
        var answer = []
        for(var i =0; i<7; i++){
            
            answer.push(date.toISOString().slice(0,10))
            date.setTime(date.getTime()-day)
        }

    
var sql = "select attendanceDate as label, count(*) as data from tbl_student_attendance where  indicator ='P' and sectionID = '"+sectionID+"' and attendanceDate IN("+answer.map(data=>'"'+data+'"')+")  GROUP BY attendanceDate order by label  "

         const fd = new FormData();
         fd.append("sql", sql);
         fd.append('jwt', Token)
         let url = ServerUrl+'/fetchBySql_controller';
         axios.post(url, fd, config).then(result=>{ 
            
             setAttendance(result.data)
         })
     }

     const fetchAttendanceAbsent =()=>{
        var date = new Date()
        const day = 1000 * 60 * 60 * 24
        var answer = []
        for(var i =0; i<7; i++){
            
            answer.push(date.toISOString().slice(0,10))
            date.setTime(date.getTime()-day)
        }

    
var sql = "select attendanceDate as label, count(*) as data from tbl_student_attendance where  indicator ='A' and sectionID = '"+sectionID+"' and attendanceDate IN("+answer.map(data=>'"'+data+'"')+")  GROUP BY attendanceDate order by label  "

         const fd = new FormData();
         fd.append("sql", sql);
         fd.append('jwt', Token)
         let url = ServerUrl+'/fetchBySql_controller';
         axios.post(url, fd, config).then(result=>{ 
            
             setAttendanceAbsent(result.data)
         })
     }





     const fetchStatistics =()=>{
        var sql ="Select (select count(*) from tbl_students where admissionStatus='Studying' and  sectionID = '"+sectionID+"' ) as student, (select count(*) from tbl_student_attendance where  indicator ='P' and sectionID = '"+sectionID+"' and attendanceDate = '"+today+"') as present,  (select count(*) from tbl_student_attendance where  indicator ='A' and sectionID = '"+sectionID+"' and attendanceDate = '"+today+"') as absent, (select count(*) from tbl_students where admissionStatus='Studying' and gender='Male' and  sectionID = '"+sectionID+"' ) as male, (select count(*) from tbl_students where admissionStatus='Studying' and gender='Female' and  sectionID = '"+sectionID+"' ) as female "
          
        const fd = new FormData();
        fd.append("sql", sql);
        fd.append('jwt', Token)
        let url = ServerUrl+'/fetchBySql_controller';
        
        axios.post(url, fd, config).then(result=>{ 
            
            setStatistics({
                student:result.data[0].student,
                present:result.data[0].present,
                absent:result.data[0].absent,
                male :result.data[0].male,
                female:result.data[0].female
            })
        })
    
    }
        
       
        


          


           var className =  getClassName(classID, sectionID, schoolClass);
           var cName = "Dashboard -"+className



           const data = {
            labels: attendance.map((data)=>data.label),
            datasets: [
              {
                label: 'Present',
                data: attendance.map((data)=>data.data),
                fill: false,
                backgroundColor: 'rgba(75,192,192,1)',
                borderColor: 'rgba(0,0,0,1)',
                yAxisID: 'y-axis-1',
              },
              {
                label: 'Absent',
                data: attendanceAbsent.map((data)=>data.data),
                fill: false,
                backgroundColor: 'rgb(54, 162, 235)',
                borderColor: 'rgb(255, 99, 132)',
                yAxisID: 'y-axis-2',
              },
            ],
          };
          
         

          const options = {
            scales: {
              yAxes: [
                {
                  type: 'linear',
                  display: true,
                  position: 'left',
                  id: 'y-axis-1',
                },
                {
                  type: 'linear',
                  display: true,
                  position: 'right',
                  id: 'y-axis-2',
                  gridLines: {
                    drawOnArea: false,
                  },
                },
              ],
            },
          }
          
         
          



          function renderEventContent(eventInfo){ 
            var data = eventInfo.event.extendedProps 
            return  <div style={{backgroundColor:data.colors}} className="attachment-block text-center">  
            <b className="text-green">{data.event}</b><br/>
            <b className="text-green" style={{display:'block',  width:150, whiteSpace:'normal', wordWrap:'break-word' }}>{data.comment}</b>
        <br/>
        <strong className="text-green">{getTime(data.begin)+ ' ~ '+getTime(data.stop)} </strong>
        <br/>
            
              
                
                <br/>
            </div>
        }

        
   useEffect(()=>{

    handleSession()
        fetchAllHolidays();
        fetchAllHoliday()

    fetchStatistics()
    fetchAttendance()
    fetchAttendanceAbsent()
    handleFetchClass()
},[]);

        return (  
            <React.Fragment>
   <DashboardStyles>
   {notice.isLoading ?<LoadEffect className="overlay floatLoad" /> : "" }
   <div className="main-body">
                <div className="page-wrapper">
                 
                   {/* <!-- Page-header start --> */}

        <PageHeader title={cName}>
        <li className="breadcrumb-item"><a  href="#!"> <i className="fa fa-fw fa-dashboard"></i> </a>
                            </li>
                            <li className="breadcrumb-item"><a href="#!">Dashboard</a> </li>
                    </PageHeader>
{/* The Page Body start here */}
                <div className="page-body">






<div className="row">
  {/* Modern Statistics Cards */}
  <div className="col-xl-3 col-md-6 mb-4">
    <div className="card border-left-primary shadow h-100 py-2">
      <div className="card-body">
        <div className="row no-gutters align-items-center">
          <div className="col mr-2">
            <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">Students</div>
            <div className="h5 mb-0 font-weight-bold text-gray-800">{statistics.student}</div>
          </div>
          <div className="col-auto">
            <i className="fa fa-users" style={{ fontSize: 36, color: '#4e73df' }}></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div className="col-xl-3 col-md-6 mb-4">
    <div className="card border-left-success shadow h-100 py-2">
      <div className="card-body">
        <div className="row no-gutters align-items-center">
          <div className="col mr-2">
            <div className="text-xs font-weight-bold text-success text-uppercase mb-1">Today Present</div>
            <div className="h5 mb-0 font-weight-bold text-gray-800">{statistics.present}</div>
          </div>
          <div className="col-auto">
            <i className="fa fa-check-circle" style={{ fontSize: 36, color: '#1cc88a' }}></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div className="col-xl-3 col-md-6 mb-4">
    <div className="card border-left-warning shadow h-100 py-2">
      <div className="card-body">
        <div className="row no-gutters align-items-center">
          <div className="col mr-2">
            <div className="text-xs font-weight-bold text-warning text-uppercase mb-1">Today Absent</div>
            <div className="h5 mb-0 font-weight-bold text-gray-800">{statistics.absent}</div>
          </div>
          <div className="col-auto">
            <i className="fa fa-times-circle" style={{ fontSize: 36, color: '#f6c23e' }}></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div className="col-xl-3 col-md-6 mb-4">
    <div className="card border-left-info shadow h-100 py-2">
      <div className="card-body">
        <div className="row no-gutters align-items-center">
          <div className="col mr-2">
            <div className="text-xs font-weight-bold text-info text-uppercase mb-1">Gender Distribution</div>
            <div className="row no-gutters align-items-center">
              <div className="col-auto">
                <div className="h5 mb-0 mr-3 font-weight-bold text-gray-800">Male: {statistics.male}</div>
              </div>
              <div className="col">
                <div className="h5 mb-0 font-weight-bold text-gray-800">Female: {statistics.female}</div>
              </div>
            </div>
          </div>
          <div className="col-auto">
            <i className="fa fa-users" style={{ fontSize: 36, color: '#36b9cc' }}></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

      <div className="row mb-4">
  <div className="col-12">
    <div className="card shadow">
      <div className="card-header py-3">
        <h6 className="m-0 font-weight-bold text-primary">Quick Access</h6>
      </div>
      <div className="card-body">
        <div className="row">
          <div className="col-md-4 col-lg-2 mb-3">
            <div className="quick-access-card" onClick={()=>window.open('/staffportal/students/view_students', '_self')}>
              <div className="icon-circle bg-primary">
                <i className="fa fa-users" style={{ fontSize: 24, color: '#fff' }}></i>
              </div>
              <div className="quick-access-title">My Students</div>
            </div>
          </div>
          
          <div className="col-md-4 col-lg-2 mb-3">
            <div className="quick-access-card" onClick={()=>window.open('/staffportal/library/books', '_self')}>
              <div className="icon-circle bg-success">
                <i className="fa fa-book" style={{ fontSize: 24, color: '#fff' }}></i>
              </div>
              <div className="quick-access-title">Library</div>
            </div>
          </div>
          
          <div className="col-md-4 col-lg-2 mb-3">
            <div className="quick-access-card" onClick={()=>window.open('/staffportal/staff/noticeboard', '_self')}>
              <div className="icon-circle bg-info">
                <i className="fa fa-bell" style={{ fontSize: 24, color: '#fff' }}></i>
              </div>
              <div className="quick-access-title">Noticeboard</div>
            </div>
          </div>
          
          <div className="col-md-4 col-lg-2 mb-3">
            <div className="quick-access-card" onClick={()=>window.open('/staffportal/attendance/student_attendance', '_self')}>
              <div className="icon-circle bg-warning">
                <i className="fa fa-calendar" style={{ fontSize: 24, color: '#fff' }}></i>
              </div>
              <div className="quick-access-title">Attendance</div>
            </div>
          </div>
          
          <div className="col-md-4 col-lg-2 mb-3">
            <div className="quick-access-card" onClick={()=>window.open('/staffportal/timetable/view_timetable', '_self')}>
              <div className="icon-circle bg-danger">
                <i className="fa fa-clock-o" style={{ fontSize: 24, color: '#fff' }}></i>
              </div>
              <div className="quick-access-title">Timetable</div>
            </div>
          </div>
          
          <div className="col-md-4 col-lg-2 mb-3">
            <div className="quick-access-card" onClick={()=>window.open('/staffportal/staff/noticeboard', '_self')}>
              <div className="icon-circle bg-secondary">
                <i className="fa fa-dashboard" style={{ fontSize: 24, color: '#fff' }}></i>
              </div>
              <div className="quick-access-title">Dashboard</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div className="row">
  <div className="col-lg-8 mb-4">
    <div className="card shadow">
      <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
        <h6 className="m-0 font-weight-bold text-primary">{className} - Weekly Attendance</h6>
      </div>
      <div className="card-body">
        <div className="chart-area">
          <Line
            data={{
              labels: attendance.map((data) => data.label),
              datasets: [
                {
                  label: 'Present',
                  data: attendance.map((data) => data.data),
                  fill: false,
                  backgroundColor: '#4e73df',
                  borderColor: '#4e73df',
                  tension: 0.3,
                  pointRadius: 3,
                  pointBackgroundColor: '#4e73df',
                  pointBorderColor: '#fff',
                  pointHoverRadius: 5,
                  pointHoverBackgroundColor: '#4e73df',
                  pointHoverBorderColor: '#fff',
                  yAxisID: 'y-axis-1',
                },
                {
                  label: 'Absent',
                  data: attendanceAbsent.map((data) => data.data),
                  fill: false,
                  backgroundColor: '#e74a3b',
                  borderColor: '#e74a3b',
                  tension: 0.3,
                  pointRadius: 3,
                  pointBackgroundColor: '#e74a3b',
                  pointBorderColor: '#fff',
                  pointHoverRadius: 5,
                  pointHoverBackgroundColor: '#e74a3b',
                  pointHoverBorderColor: '#fff',
                  yAxisID: 'y-axis-2',
                },
              ],
            }}
            options={{
              maintainAspectRatio: false,
              layout: {
                padding: {
                  left: 10,
                  right: 25,
                  top: 25,
                  bottom: 0
                }
              },
              scales: {
                xAxes: [{
                  time: {
                    unit: 'date'
                  },
                  gridLines: {
                    display: false,
                    drawBorder: false
                  },
                  ticks: {
                    maxTicksLimit: 7
                  }
                }],
                yAxes: [
                  {
                    type: 'linear',
                    display: true,
                    position: 'left',
                    id: 'y-axis-1',
                    gridLines: {
                      color: "rgb(234, 236, 244)",
                      zeroLineColor: "rgb(234, 236, 244)",
                      drawBorder: false,
                      borderDash: [2],
                      zeroLineBorderDash: [2]
                    },
                    ticks: {
                      maxTicksLimit: 5,
                      padding: 10,
                    }
                  },
                  {
                    type: 'linear',
                    display: true,
                    position: 'right',
                    id: 'y-axis-2',
                    gridLines: {
                      drawOnArea: false,
                      display: false,
                    },
                    ticks: {
                      maxTicksLimit: 5,
                      padding: 10,
                    }
                  },
                ],
              },
              legend: {
                display: true,
                position: 'bottom'
              },
              tooltips: {
                backgroundColor: "rgb(255,255,255)",
                bodyFontColor: "#858796",
                titleMarginBottom: 10,
                titleFontColor: '#6e707e',
                titleFontSize: 14,
                borderColor: '#dddfeb',
                borderWidth: 1,
                xPadding: 15,
                yPadding: 15,
                displayColors: false,
                intersect: false,
                mode: 'index',
                caretPadding: 10,
              }
            }}
          />
        </div>
      </div>
    </div>
  </div>

  <div className="col-lg-4 mb-4">
    <div className="card shadow">
      <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
        <h6 className="m-0 font-weight-bold text-primary">Upcoming Events</h6>
      </div>
      <div className="card-body">
        <div className="calendar-container" style={{ height: '400px', overflow: 'auto' }}>
          <FullCalendar
            events={allHoliday}
            eventContent={renderEventContent}
            headerToolbar={{
              left: "prev,today",
              center: "title",
              right: "next"
            }}
            plugins={[dayGridPlugin]}
            initialView="dayGridMonth"
            height="auto"
            contentHeight="auto"
          />
        </div>
      </div>
    </div>
  </div>
</div>



{/* <div className="row  ">   <div className="col-sm-12">
                               
                                                
<div className="card z-depth-0">
            <div className="card-header">
                <h5><i className="fa fa-th" ></i> Event and Holidays</h5>
                <div className="card-header-right">
                    <ul className="list-unstyled card-option">
                        <li><i className="feather icon-maximizes full-card"></i></li>
                        <li><i className="feather icon-minus minimize-card"></i></li>
                        <li><i className="feather icon-trash-2 close-card"></i></li>
                    </ul>
                </div>
            </div>
            <div className="card-block">
            <div className="col-md-12 table-responsive">

         {notice.isDataFetching ? <TableLoader />:
         <HolidayTable data={allHolidays}  columns={tableHeader}  /> 
        } 

            </div></div>
    
    </div>
    
    </div>
    </div> */}




   </div>
          {/* The Page Body close here */}

            </div>
            </div>

</DashboardStyles> 
</React.Fragment>
);
        
}

export default React.memo(Dashboard) 